import { Form, FormInstance, Radio } from 'antd';
import clsx from 'clsx';

import styles from './index.module.scss';
import {
  SubCategoryStatisticDisplayMode,
  SubCategoryStatisticDisplayUnitLabels,
} from '../../../store/subCategory';

const displayModeValues: SubCategoryStatisticDisplayMode[] = [
  'percent',
  'dollar',
];

interface RadioGroupTipTypeProps {
  form?: FormInstance;
  value?: SubCategoryStatisticDisplayMode;
  onChange?: (value: SubCategoryStatisticDisplayMode) => void;
  className?: string;
  light?: boolean;
  name?: string;
}

const RadioGroupTipType = ({
  form,
  value,
  onChange,
  className,
  light,
  name = 'tipType',
}: RadioGroupTipTypeProps) => (
  <Form.Item
    className={clsx(styles.wrapper, className, light && styles.light)}
    name={name}
  >
    <div className={styles.label}>Tip by:</div>
    <Radio.Group
      buttonStyle="solid"
      className={styles.group}
      onChange={(e) => {
        form?.setFieldValue(name, e.target.value);
        onChange?.(e.target.value);
      }}
    >
      {displayModeValues.map((mode) => (
        <Radio.Button
          key={mode}
          value={mode}
          className={clsx(
            styles.radioButton,
            mode === (form?.getFieldValue(name) || value) ? styles.active : ''
          )}
        >
          {SubCategoryStatisticDisplayUnitLabels[mode]}
        </Radio.Button>
      ))}
    </Radio.Group>
  </Form.Item>
);

export default RadioGroupTipType;
